/**
 * Whether somebody wants to see what a session costs them in energy.
 *
 * ABSENT MEANS YES, and it has to: the switch was added on 12 October 2026,
 * every profile written before that date has nothing on it, and a published
 * app talks to whatever API is deployed. Written `!== false` rather than
 * `=== true` for the same reason as the-advice-before-a-session reads its
 * field: the figures must not vanish for everybody the day the app ships
 * before the API does.
 *
 * Read here rather than cast at the call site, like weightKgOf next door: the
 * generated client is built from a running API and does not know this field.
 */
export const showsEnergyEstimatesOf = (profile: unknown): boolean => {
  const found = (profile as { showsEnergyEstimates?: unknown })?.showsEnergyEstimates;
  return found !== false;
};
